import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './QuickActions.module.css';

interface QuickActionsProps {
  orderId?: number | string;
}

export const QuickActions: React.FC<QuickActionsProps> = ({ orderId }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Quick Actions</h3>
      <button
        type="button"
        className={styles.primary}
        onClick={() => navigate('/new-order' + (orderId ? `?from=${orderId}` : ''))}
      >
        ✏ Edit Order
      </button>
      <button
        type="button"
        className={styles.secondary}
        onClick={() => navigate('/new-order' + (orderId ? `?duplicate=${orderId}` : ''))}
      >
        + Duplicate Order
      </button>
      <button
        type="button"
        className={styles.secondary}
        onClick={() => window.print()}
      >
        🖨 Print Invoice
      </button>
    </div>
  );
};
